import { Routes, Route, Navigate } from 'react-router-dom';
import { IdentityProvider } from 'context/identity-provider';
import ProtectedRoute from 'components/ProtectedRoute';
import LandingRoute from 'components/LandingRoute';
import ResumeView from 'pages/resume-view';
import LoginView from 'pages/login-view';
import PortalView from 'pages/portal-view';
import styles from './app.module.scss';

const App: React.FC = () => {
  return (
    <div className={styles.appRoot}>
      <IdentityProvider>
        <Routes>
          <Route path="/" element={<LandingRoute />} />
          <Route path="/resume" element={<ResumeView />} />
          <Route path="/login" element={<LoginView />} />
          <Route
            path="/portal"
            element={
              <ProtectedRoute>
                <PortalView />
              </ProtectedRoute>
            }
          />
          {/* legacy links */}
          <Route path="/resume-creative" element={<Navigate to="/" replace />} />
          <Route path="/dashboard" element={<Navigate to="/portal" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </IdentityProvider>
    </div>
  );
};

export default App;
